import React from 'react';

const InternationalConferencesIntroduction = () => (
  <section
    className="international-conferences-introduction"
    aria-labelledby="international-conferences-introduction-title"
  >
    <div className="international-conferences-introduction-inner">
      <p className="section-eyebrow">GLOBAL DIALOGUE · SHARED DISCOVERY</p>
      <h1 id="international-conferences-introduction-title">International Conferences</h1>
      <div className="world-space-week-title-line" aria-hidden="true" />
      <p>
        The National Center of GIS and Space Applications (NCGSA) organizes international
        conferences that provide distinguished forums for advancing knowledge and promoting dialogue
        in the fields of space science, technology, and education. These conferences convene leading
        experts, researchers, policymakers, educators, and students from across the globe to exchange
        insights, present pioneering research, and explore collaborative opportunities. By enabling
        cross-cultural engagement and promoting international cooperation, NCGSA conferences
        contribute to shaping the future of space awareness, innovation, and education on a global scale.
      </p>
    </div>
  </section>
);

export default InternationalConferencesIntroduction;
